import routes from '../../config/routes';

const buildCollectionPageUrl = (slug: string) => {
  return `${routes.collection}/${slug}`;
};

export default buildCollectionPageUrl;
